<template>
    <div class="hero-body is-paddingless" id="wrap-svg">
        <svg id="svg-scheme-list" preserveAspectRatio="xMinYMin meet">
            <defs>
                <!--                <pattern id="pattern-section31323" width="7" height="7" patternUnits="userSpaceOnUse" x="1" y="0">-->
                <!--                    <image xlink:href="https://s1.iconbird.com/ico/2013/3/635/w296h2201393885383113.png" width="7"-->
                <!--                           height="7"/>-->
                <!--                </pattern>-->

                <!-- Балкон левая сторона откидное -->
                <pattern id="pattern-section31323_0" x="0" y="0" width="7" height="7" patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31323_1" x="0" y="0" width="7" height="7" patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Балкон правая сторона откидное -->
                <pattern id="pattern-section31321_0" x="2" y="0" width="7" height="7" patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31321_1" x="2" y="0" width="7" height="7" patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Балкон середина -->
                <pattern id="pattern-section31319_0" x="0" y="0" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#3d96d1" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31319_1" x="0" y="0" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#3d96d1" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31319_2" x="0" y="-2" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#3d96d1" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31319_3" x="0" y="-2" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#3d96d1" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31319_4" x="0" y="-2.5" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#3d96d1" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Ложа балкон левая -->
                <pattern id="pattern-section31318_0" x="0" y="-3.5" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31318_1" x="0" y="-3.5" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31318_2" x="0" y="-3.5" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Ложа балкон правая -->
                <pattern id="pattern-section31317_0" x="0" y="-3.5" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31317_1" x="0" y="-3.5" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31317_2" x="0" y="-3.5" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Амфитеатр правая сторона -->
                <pattern id="pattern-section31326_0" x="7" y="-1" width="7.935" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#3d96d1" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Амфитеатр левая сторона -->
                <pattern id="pattern-section31327_0" x="-4" y="-1" width="7.935" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#3d96d1" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Партер середина -->
                <pattern id="pattern-section31325_0" x="-4" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31325_1" x="-4" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31325_2" x="-4" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31325_3" x="-3.5" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31325_4" x="-4" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31325_5" x="-4" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31325_6" x="-4" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31325_7" x="-3.5" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#c32e54" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Амфитеатр середина -->
                <pattern id="pattern-section31324_0" x="-1.1" y="-1" width="7.935" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#f4bb59" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31324_1" x="-1.1" y="-1" width="7.75" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#f4bb59" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section31324_2" x="3" y="-1" width="7.935" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#f4bb59" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Партер правая сторона -->
                <pattern id="pattern-section30209_0" x="-1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section30209_1" x="-1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section30209_2" x="-1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section30209_3" x="-1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Партер левая сторона -->
                <pattern id="pattern-section30210_0" x="1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section30210_1" x="1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section30210_2" x="1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section30210_3" x="1" y="0" width="7.8" height="7.925"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#469c58" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Балкон правая сторона -->
                <pattern id="pattern-section104_0" x="1" y="0" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#f4bb59" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section104_1" x="1" y="-4.5" width="7.85" height="7.95"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#f4bb59" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>

                <!-- Балкон левая сторона -->
                <pattern id="pattern-section105_0" x="-1" y="0" width="7.85" height="7.75"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#f4bb59" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
                <pattern id="pattern-section105_1" x="-1" y="-4.5" width="7.85" height="7.95"
                         patternUnits="userSpaceOnUse">
                    <circle fill="#f4bb59" cx="3.5" cy="3.5" r="1.75"></circle>
                </pattern>
            </defs>
            <g class="svg-pan-zoom_viewport_list">
                <!--                @click="goToSection(section)"-->
                <g v-for="(section, indexSection) in hallPlan" v-bind:key="section.sectorId"
                   @mousemove="sectionHover($event, section)"
                   @mouseleave="sectionUnHover"
                   class="section-item"
                   :class="{'disabled':section.freePlaceQuantity === 0}"
                   :id="`section${section.sectorId}`">
                    <w-polygon v-for="(polygon, index) in section.polygons"
                               :polygon="polygon"
                               :lengthPolygons="section.polygons.length"
                               :lengthSections="hallPlan.length"
                               :indexThisPolygon="index"
                               :indexThisSection="indexSection"
                               :idSection="section.sectorId"
                               v-bind:key="index"/>
                    <text v-if="section.headerCoords"
                          :x="section.headerCoords.x" :y="section.headerCoords.y"
                          class="section-item__name is-size-7"
                          :class="`section${section.sectorId}`">
                        {{section.name}}
                        <!--                        :rotate="section.headerAngle"-->
                    </text>
                </g>
            </g>
        </svg>
        <div class="control-zoom">
            <button class="control-zoom__button button is-rounded plus" @click="zoomPlus">
                      <span class="icon is-large">
                      <i class="mdi mdi-24px mdi-plus"></i>
                    </span>
            </button>
            <button class="control-zoom__button button is-rounded minus" @click="zoomMinus">
                    <span class="icon is-large">
                      <i class="mdi mdi-24px mdi-minus"></i>
                    </span>
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {svgMixin} from "../mixins/svgMixin";
    import WPolygon from "./WPolygon";

    export default {
        name: "SectionsList",
        mixins: [svgMixin],
        computed: {
            ...mapState({
                hallPlan: state => state.hallPlan,
            }),
        },
        components: {
            WPolygon
        },
        data() {
            return {}
        },
        methods: {
            goToSection(id) {
                let section = this.hallPlan.find(i => i.sectorId === parseInt(id));

                if (section.freePlaceQuantity > 0) {
                    this.$router.push({name: 'Section', params: {section_id: section.sectorId}})
                }
            },
            sectionHover(event, section) {
                if (!this.pan) {


                    let allSections = document.getElementsByClassName("section-item");
                    allSections.forEach(item => {
                        item.classList.add("small-opacity");
                    });

                    let sectionInfo = {
                        section: section.name,
                        freePlaceQuantity: section.freePlaceQuantity,
                        maxTicketCost: section.maxTicketCost,
                        minTicketCost: section.minTicketCost,
                        position: {
                            left: event.pageX + "px",
                            top: event.pageY + "px"
                        }
                    };
                    this.$events.fire('showTooltip', sectionInfo);
                }
            },
            sectionUnHover() {
                this.$events.fire('hideTooltip');
                let allSections = document.getElementsByClassName("section-item");
                allSections.forEach(item => {
                    item.classList.remove("small-opacity");
                });
            },
        },
        mounted() {
            this.setHeaderSVG('svg-scheme-list');
        },
        events: {
            endRenderSectionsList() {
                this.initPanZoom('svg-scheme-list');
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/variables";

    svg {
        width: 100%;
    }

    .hero {
        &-body {
            height: 100%;
            flex: 1;
            position: relative;
            align-items: normal !important;
        }
    }

    .section-item {
        cursor: pointer;

        polygon,
        text {
            transition: 0.2s ease-in-out;
            opacity: 0.75;
        }

        &.disabled {
            cursor: not-allowed;

            polygon,
            text {
                opacity: 0.5;
            }
        }

        &.small-opacity {
            polygon,
            text {
                opacity: 0.25;
            }
        }

        &:hover {
            polygon,
            text {
                opacity: 1;
            }

            &.disabled {
                polygon,
                text {
                    opacity: 0.625;
                }
            }
        }

        &__name {
            fill: #fafafa;


            &.section31321 {
                /*writing-mode: vertical-rl;*/
                /*transform: translate(-1.375rem, 4rem);*/
                transform: translate(104.5rem, - 24.75rem) rotate(90deg);
            }

            &.section31323 {
                /*writing-mode: vertical-rl;*/
                /* transform: translate(1.5rem, -8.5rem);*/
                transform: translate(-42rem, 57rem) rotate(-90deg);
            }

            &.section104 {
                transform: translate(3rem, 1rem);
            }

            &.section105 {
                transform: translate(3rem, 1rem);
            }

            &.section31319 {
                transform: translate(0.635rem, 0.75rem);
            }

            &.section31317 {
                transform: translate(4.635rem, 0.75rem);
            }

            &.section31318 {
                transform: translate(1.35rem, 0.75rem);
            }

            &.section31324 {
                transform: translate(2.25rem, 0.75rem);
            }

            &.section31326 {
                transform: translate(0rem, 1rem);
            }

            &.section31327 {
                transform: translate(1rem, 1rem);
            }

            &.section30210 {
                transform: translate(3rem, 1rem);
            }

            &.section30209 {
                transform: translate(0rem, 1rem);
            }

            &.section31325 {
                transform: translate(1.5rem, 1rem);
            }
        }
    }
</style>
